import { createAction, props } from '@ngrx/store';
import { ITimeBlockComponentItem } from '../../../../features/calendar/components/time-block/types/time-block-component-item-types';
import { TimerStatus } from '../../../../features/calendar/calendar-types';

export const postTimer = createAction(
  '[Timer] Post Timer',
  props<{
    payload: {
      status: TimerStatus;
      taskId: number;
    };
  }>(),
);

export const timerPosted = createAction(
  '[Timer] Timer Posted',
  props<{
    payload: {
      status: TimerStatus;
      generatedTimeBlock: ITimeBlockComponentItem;
    };
  }>(),
);
